<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-05 17:55:59
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:23:59
 * @FilePath: \zhucai_user\src\pages\course\child\rightSide.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dl v-loading="isLoading" class="width340">
    <dt class="BGwhite size16 radius8 gray1 flex pad22 b500 height60px flex between dtTitle">
      讲师
      <div class="grid2 gap10 part39 center jiantou" v-if="list.length > 1">
        <img src="@/assets/img/home/20.png" alt="" class="btn" @click="prev" />
        <img src="@/assets/img/home/19.png" alt="" class="btn" @click="next" />
      </div>
    </dt>
    <div v-if="list.length > 0" class="info">
      <div class="info-left">
        <img :src="info.Avatar" alt="" @error="imgError" />
      </div>
      <div class="info-right">
        <p class="TeacherName">{{ info.TeacherName }}</p>
        <p class="PropValue">{{ showProp(info) }}</p>
        <el-button class="testBtn" @click="booking">预约讲师</el-button>
      </div>
    </div>
    <div v-else class="info">
      <el-empty description="暂无内容" :image="empty1" />
    </div>
    <dt class="BGwhite size16 radius8 gray1 flex pad22 mt20 b500 height60px flex between dtTitle">
      相关课程
    </dt>
    <div v-if="list2.length > 0" class="info2">
      <div class="table-item" v-for="(item, index) in list2" :key="index" @click="toDetail(item)">
        <div class="img">
          <img :src="item.ImgPath" @error="imgError" alt="" />
        </div>
        <div class="content">
          {{ item.CourseName }}
        </div>
        <div class="flex mt20">
          <div class="type"># {{ item.CourseName }}</div>
          <div class="red">
            ¥ <span class="amout">{{ item.Price }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="rate">
            <span class="mr5">{{ parseFloat(item.StarNum).toFixed(1) }}</span>
            <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
            </el-rate>
          </div>
          <div class="user">
            <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="预约讲师" :visible.sync="dialogShow" class="width510" @close="close" :append-to-body="true">
      <div class="my-form">
        <div class="flexs">
          <div class="mt-form-item">
            <div class="label">
              联系人姓名
              <span class="must">(必填)</span>：
            </div>
            <el-input v-model="model.RealName" placeholder="请填写联系人姓名"></el-input>
          </div>
          <div class="mt-form-item">
            <div class="label">
              联系人电话
              <span class="must">(必填)</span>：
            </div>
            <el-input v-model="model.Phone" placeholder="请填写联系人电话"></el-input>
          </div>
        </div>
        <div class="mt-form-item">
          <div class="label">
            课程需要
            <span class="must">(非必填)</span>：
          </div>
          <el-input v-model="model.Body" placeholder="请填写您的课程需求" type="textarea" :rows="8"></el-input>
        </div>
        <div class="mt-form-item valiCode">
          <el-input placeholder="验证码" v-model="model.valiCode"> </el-input>
          <identify ref="identify" :height="46" :width="150" class="identify" />
        </div>
      </div>
      <div slot="footer">
        <el-button class="submit-btn" @click="submit()">确定</el-button>
      </div>
    </el-dialog>
  </dl>
</template>

<script>
import { Course_GetTeachers, Course_GetRelatedCourses } from "@/api/course";
import { Teacher_Prebook } from "@/api/teacher";
import identify from "@/components/identify.vue";
export default {
  name: "demo",
  components: {
    identify,
  },
  data() {
    return {
      list: [],
      list2: [],
      count: 0,
      page: 0,
      isLoading: false,
      info: {},
      dialogShow: false,
      model: {
        RealName: "",
        Phone: "",
        Body: "",
        valiCode: "",
      },
    };
  },
  methods: {
    showProp(item) {
      let showItem = item.Props.filter((item) => item.IsShow)
      if (showItem[0]) {
        return showItem[0].PropValue;
      } else {
        return item.PropValue
      }
    },
    submit() {
      if (this.model.RealName.trim().length === 0) {
        this.$message.error("联系人姓名不能为空");
        return false;
      }
      if (this.model.Phone.trim().length === 0) {
        this.$message.error("联系人电话不能为空");
        return false;
      }
      if (this.model.valiCode.trim().length === 0) {
        this.$message.error("图片验证码不能为空");
        return false;
      } else if (this.model.valiCode !== this.$refs.identify.identifyCode) {
        this.$message.error("图片验证码不正确");
        return false;
      }
      Teacher_Prebook({
        ...this.model,
        TeacherID: this.info.TeacherID,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("预约成功");
          this.dialogShow = false;
        } else {
          this.$refs.identify.drawPic();
        }
      });
    },
    booking() {
      // this.dialogShow = true;
      this.$router.push({
        path: "/teacherDetail",
        query: { TeacherID: this.info.TeacherID },
      });
    },
    close() {
      this.dialogShow = false;
      this.model = {
        RealName: "",
        Phone: "",
        Body: "",
        valiCode: "",
      };
      this.$refs.identify.drawPic();
    },
    toDetail(item) {
      console.log(item);
      this.$router.push({
        path: "/courseDetail",
        query: { CourseID: item.CourseID },
      });
    },
    prev() {
      if (this.page == 0) return;
      this.page--;
      this.info = this.list[this.page];
    },
    next() {
      if (this.page == this.count - 1) return;
      this.page++;
      this.info = this.list[this.page];
    },
    getDetail() {
      this.isLoading = true;
      Course_GetTeachers({ CourseID: this.$route.query.CourseID })
        .then((res) => {
          this.isLoading = false;
          this.list = res.data;
          this.info = res.data[0];
          this.count = res.data.length;
        })
        .finally(() => {
          this.isLoading = false;
        });
      Course_GetRelatedCourses({
        CourseID: this.$route.query.CourseID,
        Size: 2,
      })
        .then((res) => {
          this.list2 = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.width340 {
  width: 340px;
}

.dtTitle {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}

.jiantou {
  .btn {
    cursor: pointer;
    margin-top: -5px;
    width: 28px;
    height: 28px;
  }
}

.info {
  margin-top: 1px;
  width: 340px;
  height: 194px;
  padding: 15px;
  display: flex;
  gap: 20px;
  background: #ffffff;
  border-radius: 10px;

  .info-left {
    width: 130px;
    height: 160px;
    overflow: hidden;
    border-radius: 6px;

    img {
      width: 130px;
      height: 160px;
      border-radius: 6px;
    }
  }

  .info-right {
    position: relative;

    .TeacherName {
      margin-top: 10px;
      font-size: 20px;
      color: #333333;
    }

    .PropValue {
      margin-top: 5px;
      font-size: 16px;
      color: #999999;
    }

    .testBtn {
      position: absolute;
      bottom: 10px;
      height: 36px;
      line-height: 12px;
      background: #ffffff;
      border-radius: 6px;
      font-size: 16px;
      border: 1px solid #cccccc;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.info2 {
  margin-top: 1px;
  display: block;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 420px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .img {
      width: 308px;
      height: 231px;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .type {
        font-size: 16px;
        color: #999999;
      }

      .amout {
        font-size: 24px;
        font-weight: bold;
      }

      .red {
        font-size: 16px;
        color: #e12a14;
        font-weight: bold;

      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;

        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }

      .rate {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}

.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}

.my-form {
  .mt-form-item {
    margin-bottom: 20px;

    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }

    .must {
      color: #ef3d3d;
    }
  }

  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }

  .flexs {
    display: flex;
    gap: 10px;

    ::v-deep .el-input__inner {
      width: 228px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }

  .valiCode {
    display: flex;

    ::v-deep .el-input__inner {
      width: 340px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }
}

.identify {
  width: 150px;
  height: 46px;
  overflow: hidden;
  border-radius: 4px;
}

.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
